<template>
  <div class="af-modal-card" style="width: 650px">
    <span class="modal-card__content">
      <span v-if="isEmailExists && !newCodeSent">
        <p class="has-text-weight-bold is-size-4 mb-4">
          {{ $t("af:applications.leasing_email_confirmation_modal.email_exist.title") }}
        </p>

        <p>
          <span
            v-html="
              $t(
                'af:applications.leasing_email_confirmation_modal.email_exist.subtitle',
                {
                  email: email,
                }
              )
            "
          ></span>
        </p>

        <p class="has-text-weight-bold has-text-centered mt-5">
          <b-button type="is-blue" @click="sendNewCode">
            {{
              $t(
                "af:applications.leasing_email_confirmation_modal.email_exist.button.send_new_code"
              )
            }}</b-button
          >
        </p>

        <span v-if="!changeEmail">
          <p class="has-text-weight-bold has-text-centered mt-6">
            <span
              class="af-text-button has-text-blue"
              @click="changeEmail = true"
            >
              {{
                $t(
                  "af:applications.leasing_email_confirmation_modal.email_exist.button.change_email"
                )
              }}</span
            >
          </p>
        </span>
      </span>

      <span v-if="!isEmailExists && !newCodeSent">
        <p class="has-text-weight-bold is-size-4 mb-4">
          {{
            $t("af:applications.leasing_email_confirmation_modal.email_not_exist.title")
          }}
        </p>

        <p>
          {{
            $t(
              "af:applications.leasing_email_confirmation_modal.email_not_exist.subtitle"
            )
          }}
        </p>
      </span>

      <div v-if="changeEmail && !newCodeSent" class="mt-5">
        <form autocomplete="new-password">
          <validation-observer ref="observer">
            <BInputWithValidation
              rules="required|email"
              :label="
                $t(
                  'af:applications.leasing_email_confirmation_modal.change_email.email.label'
                )
              "
              label-position="on-border"
              v-model="newEmail"
              name="application-email"
            />

            <!-- <ValidationProvider
              rules="required"
              v-slot="{ errors, validated, valid }"
            >
              <b-field
                :label="
                  $t(
                    'af:applications.leasing_email_confirmation_modal.change_email.password.label'
                  )
                "
                label-position="on-border"
                name="application-code"
                class="mb-5"
                :type="{
                  'is-danger': errors[0],
                  'is-success': validated && valid,
                }"
                :message="errors"
              >
                <b-input
                  type="password"
                  autocomplete="new-password"
                  password-reveal
                  v-model="password"
                ></b-input>
              </b-field>
            </ValidationProvider> -->
          </validation-observer>
        </form>
        <p class="has-text-weight-bold has-text-centered mt-5">
          <b-button type="is-blue" @click="sendNewCodeToNewEmail">
            {{
              $t(
                "af:applications.leasing_email_confirmation_modal.change_email.button.submit"
              )
            }}
          </b-button>
        </p>
      </div>

      <div v-if="newCodeSent">
        <p class="has-text-weight-bold is-size-4 mb-4">
          {{ $t("af:applications.leasing_email_confirmation_modal.email_sent.title") }}
        </p>

        <p>
          <span
            v-html="
              $t(
                'af:applications.leasing_email_confirmation_modal.email_sent.subtitle',
                {
                  email: email,
                }
              )
            "
          ></span>
        </p>

        <img
          class="mx-auto is-block"
          :src="require('@/assets/images/mail-sent.svg')"
          alt="mail-sent"
        />
        <form @submit.prevent="sendTwoFactorCode">
          <validation-observer ref="observer">
            <ValidationProvider
              rules="required"
              v-slot="{ errors, validated, valid }"
            >
              <b-field
                :label="
                  $t(
                    'af:applications.leasing_email_confirmation_modal.change_email.otp.label'
                  )
                "
                label-position="on-border"
                class="mb-5"
                :type="{
                  'is-danger': errors[0],
                  'is-success': validated && valid,
                }"
                :message="errors"
              >
                <b-input v-model="twoFactorCode" type="phone" />
              </b-field>
            </ValidationProvider>
          </validation-observer>
          <b-button nativeType="submit">
            {{ $t("af:applications.leasing_email_confirmation_modal.button.submit") }}
          </b-button>
        </form>
      </div>
    </span>

    <div class="close-btn cursor-pointer" @click="cancelModal">
      <b-icon icon-pack="fas" icon="times" type="is-grey-icon" />
    </div>
  </div>
</template>

<script>
import { generateNonce } from "../utils/util";
import i18n from "@/plugins/i18n";

export default {
  name: "EmailConfirmationModal",
  props: {
    currentEmail: {
      type: [String, undefined],
      required: false,
    },
  },
  components: {
    BInputWithValidation: () => import("@/components/BInputWithValidation.vue"),
  },
  data() {
    return {
      newCodeSent: false,
      changeEmail: false,
      email: "",
      newEmail: "",
      password: "",
      twoFactorId: null,
      twoFactorCode: null,
      twoFactorNonce: null,
    };
  },
  computed: {
    isEmailExists() {
      return !!this.currentEmail;
    },
  },
  async created() {
    this.email = this.currentEmail;
    this.changeEmail = !this.isEmailExists;
  },
  methods: {
    cancelModal() {
      this.$parent.close();
    },
    async sendNewCodeToNewEmail() {
      let valid = await this.$refs.observer.validate();
      if (!valid) {
        return;
      }

      try {
        this.twoFactorNonce = generateNonce();
        this.twoFactorId = await this.$store.dispatch("profile/emailChange", {
          nonce: this.twoFactorNonce,
          email: this.newEmail,
          password: this.password,
          isLeasing: true,
        });
        this.email = this.newEmail;
        this.changeEmail = false;
        this.newCodeSent = true;
      } catch (ex) {
        if (ex.response.status === 409) {
          this.$buefy.toast.open({
            message: i18n.t(
              "af:applications.leasing_email_confirmation_modal.change_email.message.email_exist"
            ),
            type: "is-danger",
          });
        }
        if (ex.response.status === 406) {
          this.$buefy.toast.open({
            message: i18n.t(
              "af:applications.leasing_email_confirmation_modal.change_email.message.password_error"
            ),
            type: "is-danger",
          });
        }
      }
    },
    async sendNewCode() {
      this.twoFactorNonce = generateNonce();
      this.twoFactorId = await this.$store.dispatch(
        "profile/sendConfirmationEmail",
        {nonce: this.twoFactorNonce, isLeasing:true }
      );
      this.newCodeSent = true;
    },
    async sendTwoFactorCode() {
      let valid = await this.$refs.observer.validate();
      if (!valid) {
        return;
      }
      try {
        await this.$store.dispatch("profile/confirmEmail", {
          id: this.twoFactorId,
          code: this.twoFactorCode,
          nonce: this.twoFactorNonce,
        });
        this.$parent.close();
        this.$buefy.toast.open({
          message: i18n.t(
            "af:applications.leasing_email_confirmation_modal.change_email.message.two_factor_solution_acceppted"
          ),
          type: "is-success",
        });
      } catch {
        this.$buefy.toast.open({
          message: i18n.t(
            "af:applications.leasing_email_confirmation_modal.change_email.message.wrong_two_factor_solution"
          ),
          type: "is-danger",
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/colors.scss";

.modal-card {
  background: white;
  border: 1px solid $grey-lightest;
  border-radius: 24px;
  position: relative;
  padding: 1rem;
  width: 100%;
  max-height: 90vh;

  .close-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    height: 32px;
    width: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

@media only screen and (min-width: 769px) {
  .modal-card {
    padding: 48px;
  }
}
</style>
